import { AlertTriangle, CheckCircle2, Copy } from "lucide-react";

type Props = {
  importable: number;
  errors: number;
  duplicates: number;
  newLots: { name: string; stage: string }[];
};

export function ImportPreviewSummary({ importable, errors, duplicates, newLots }: Props) {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2" data-testid="import-summary-counts">
        <Stat
          icon={<CheckCircle2 size={16} strokeWidth={2} />}
          label="Listos para importar"
          value={importable}
          tone="ok"
        />
        <Stat
          icon={<AlertTriangle size={16} strokeWidth={2} />}
          label="Con error"
          value={errors}
          tone={errors > 0 ? "warn" : "neutral"}
        />
        <Stat
          icon={<Copy size={16} strokeWidth={2} />}
          label="Duplicados"
          value={duplicates}
          tone={duplicates > 0 ? "warn" : "neutral"}
        />
      </div>

      {newLots.length > 0 ? (
        <div className="rounded-2xl border border-app-border bg-app-surface px-4 py-3">
          <p className="mb-2 text-app-ink-3 text-xs uppercase tracking-wider">
            Lotes nuevos que se crearán ({newLots.length})
          </p>
          <ul className="flex flex-wrap gap-2">
            {newLots.map((lot) => (
              <li
                key={lot.name}
                className="rounded-xl bg-app-surface-2 px-2.5 py-1 font-medium text-[13px] text-app-ink-1"
              >
                {lot.name}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}

type Tone = "ok" | "warn" | "neutral";

const TONE_CLASSES: Record<Tone, string> = {
  ok: "bg-app-emerald-bg text-app-emerald-ink",
  warn: "bg-app-amber-bg text-app-amber",
  neutral: "bg-app-surface-2 text-app-ink-2",
};

function Stat({
  icon,
  label,
  value,
  tone,
}: {
  icon: React.ReactNode;
  label: string;
  value: number;
  tone: Tone;
}) {
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-2xl px-3 py-1.5 font-medium text-sm ${TONE_CLASSES[tone]}`}
    >
      {icon}
      <span className="font-mono tabular-nums">{value}</span>
      <span className="font-normal">{label}</span>
    </div>
  );
}
